module.exports = __webpack_public_path__ + "static/media/BuyAKitIcon.22ed9d4a.png";